import React from 'react';
import styled from 'styled-components';

const Message = styled.div`
`;

export default function MessageDefinition(text) {
	if (!(this instanceof MessageDefinition)) {
		return new MessageDefinition(text);
	}

	this.validateAll = function() {
	};

	this.render = function(ctx, key = 0) {
		let t = typeof text === 'function' ? text(ctx) : text;
		return (
			<Message key={key}>{t}</Message>
		);
	};
}
